import { render, staticRenderFns } from "./offerInfo.vue?vue&type=template&id=0b5e72a4&scoped=true&"
import script from "./offerInfo.vue?vue&type=script&lang=js&"
export * from "./offerInfo.vue?vue&type=script&lang=js&"
import style0 from "./offerInfo.vue?vue&type=style&index=0&id=0b5e72a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e72a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDivider,VImg})
